// Mock data for initial tokens (empty to start fresh)
export const mockTokens = [];

// Utility functions
export const generateTokenId = (countryCode, partyId, tokenType) => {
  const typePrefix = tokenType === 'RFID' ? 'RFID' : 
                    tokenType === 'MOBILE' ? 'MOBILE' : 
                    tokenType === 'AD_HOC_USER' ? 'ADHOC' : 'OTHER';
  return `${countryCode}-${partyId}-${typePrefix}-${Math.random().toString(36).substr(2, 3).toUpperCase()}`;
};

export const generateTokenUid = () => {
  return Math.random().toString().substr(2, 10);
};

export const formatLastUpdated = (dateString) => {
  return new Date(dateString).toLocaleString();
};

export const exportTokensToJson = (tokens) => {
  const dataStr = JSON.stringify(tokens, null, 2);
  const dataUri = 'data:application/json;charset=utf-8,'+ encodeURIComponent(dataStr);
  
  const exportFileDefaultName = `ocpi-tokens-export-${new Date().toISOString().split('T')[0]}.json`;
  
  const linkElement = document.createElement('a');
  linkElement.setAttribute('href', dataUri);
  linkElement.setAttribute('download', exportFileDefaultName);
  linkElement.click();
};

export const exportSelectedTokensToJson = (tokens, selectedIds) => {
  const selectedTokens = tokens.filter(token => selectedIds.includes(token.id));
  exportTokensToJson(selectedTokens);
};

export const validateTokenImport = (importedData) => {
  if (!Array.isArray(importedData)) {
    throw new Error('Invalid format: Expected an array of tokens');
  }
  
  const requiredFields = ['tokenUid', 'countryCode', 'partyId', 'tokenType', 'contractId', 'issuer'];
  
  importedData.forEach((token, index) => {
    requiredFields.forEach(field => {
      if (!token[field]) {
        throw new Error(`Token at index ${index} is missing required field: ${field}`);
      }
    });
  });
  
  return true;
};

export const processImportedTokens = (importedData) => {
  return importedData.map(token => ({
    ...token,
    id: token.id || generateTokenId(token.countryCode, token.partyId, token.tokenType),
    lastUpdated: new Date().toISOString(),
    selected: false,
    isValid: token.isValid !== undefined ? token.isValid : true
  }));
};

export const filterTokens = (tokens, searchTerm, typeFilter, statusFilter) => {
  return tokens.filter(token => {
    const matchesSearch = !searchTerm || 
      token.tokenUid.toLowerCase().includes(searchTerm.toLowerCase()) ||
      token.issuer.toLowerCase().includes(searchTerm.toLowerCase()) ||
      token.contractId.toLowerCase().includes(searchTerm.toLowerCase()) ||
      token.id.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesType = typeFilter === 'All Types' || token.tokenType === typeFilter;
    const matchesStatus = statusFilter === 'All Status' || 
      (statusFilter === 'Valid' && token.isValid) ||
      (statusFilter === 'Invalid' && !token.isValid);
    
    return matchesSearch && matchesType && matchesStatus;
  });
};